export const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
export const SIX_MONTHS_MS = 6 * 30 * 24 * 60 * 60 * 1000;

function getPlacementTestDate(lastPlacementTest) {
  const date = lastPlacementTest?.date;
  if (!date) return null;
  if (date instanceof Date) return date;
  if (typeof date.toDate === 'function') return date.toDate();
  const parsedDate = new Date(date);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function shouldPromptPlacementTest({
  hasCompletedOnboarding = false,
  hasUrlOverride = false,
  placementTestStartedThisSession = false,
  lastSkippedAt = null,
  lastAttemptedAt = null,
  currentUserLevel = null,
  lastPlacementTest = null,
  hasSeenTutorial = false,
  hasAcknowledged = false,
  nativeLanguage = null,
  targetLanguage = null,
  now = Date.now(),
} = {}) {
  if (!hasCompletedOnboarding) {
    return false;
  }

  if (!nativeLanguage || !targetLanguage) {
    return false;
  }

  if (placementTestStartedThisSession && !hasUrlOverride) {
    return false;
  }

  if (lastSkippedAt) {
    const skippedAt = Number.parseInt(lastSkippedAt, 10);
    if (!Number.isNaN(skippedAt) && now - skippedAt < ONE_WEEK_MS) {
      return false;
    }
  }

  // A test that was started but never finished leaves no completion record, so the
  // "has a level but no placement test" branch below would re-prompt on every new
  // session — forever, since sessionStorage dies with the tab. A learner whose test
  // broke got asked to retake it five times that way (MAD-788). An abandoned attempt
  // earns the same cooldown as an explicit skip; taking the test from the activity
  // list is unaffected, since only the automatic prompt reads this.
  if (lastAttemptedAt && !hasUrlOverride) {
    const attemptedAt = Number.parseInt(lastAttemptedAt, 10);
    if (!Number.isNaN(attemptedAt) && now - attemptedAt < ONE_WEEK_MS) {
      return false;
    }
  }

  if (hasUrlOverride) {
    return true;
  }

  if (currentUserLevel) {
    const lastTestDate = getPlacementTestDate(lastPlacementTest);
    if (!lastTestDate) {
      return true;
    }
    return now - lastTestDate.getTime() >= SIX_MONTHS_MS;
  }

  return hasSeenTutorial === true && hasAcknowledged === true;
}
